export const ROUTES = {
    PUBLIC: {
        BLANK: '/',
        EVENT: '/event/:id',
    },
    AUTHORIZED: {
        STREAMING: '/mobileStreaming/:UUID',
        EVENT: '/event/:id',
        PUBLISH_EVENT: '/publish_event',
        RALLY: '/rally',
    },
};

export const MOBILE_BREAKPOINT = 768;
